<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'survey-list'"
    :setLoading="setLoading"
    :loadDataGrid="loaded"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "../../_mixins/data-grid.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import {
  CustomerTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/customer/customer-tabs";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { CacheService } from "../../_services/cache/cache-service";
import { SalesOrderListService } from "../../_services/api/sales/sales-order-list.service";

function logDev() {
  // eslint-disable-next-line no-console
  console.log("CX LOG Survey list >>> ", arguments);
}

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      loaded: false,
      gcPopupCustomerStatementConfig: {},
      CustomerSalesRepresentativeCode: undefined,
    };
  },
  computed: {
    defaultDateFilterValue() {
      return new Date();
      // let d = new Date();
      // d.setMonth(d.getMonth() - 3);
      // return d;
    },
    getCustomerRepDefault() {
      if (this.CustomerSalesRepresentativeCode)
        return [this.CustomerSalesRepresentativeCode];
      else return false;
    },
    setScreenConfig() {
      var config = {
        title: "Customers",
        selectedIndex: GetIndexByTabName("Surveys"),
        tabs: CustomerTabs,
        exportFileName: "Customers Surveys",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "SurveyResponseList",
              filter: [["Status", "<>", "X"]],
              serverPaging: true,
              allowGrouping: false,
              select: ["RecordId"].concat(
                this.getSelectFields(this.getColumns)
              ),
              postProcessCallback: this.surveyResponseListPostProcessCallback,
            },

            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Call Logs",
                message: "Get Started, Add a Call Log",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/surveys/create",
                clickAction: {},
                buttonLocation: "left",
                visible: false,
              },
            ],
            filterOnEnter: true,
          },
          columns: this.getColumns,
        },
      };

      return config;
    },
    getColumns() {
      return [
        {
          screenField: "Customer",
          sortIndex: 0,
          cellTemplateRecord: {
            primary: [
              {
                dataField: "CustomerName",
              },
            ],
            secondary: [
              {
                dataField: "CustomerCode",
              },
            ],
          },
          exportFields: [
            {
              dataField: "CustomerCode",
              label: "Customer Code",
            },
            {
              dataField: "CustomerName",
              label: "Customer Name",
            },
          ],
          fixed: true,
          fixedPosition: "left",
          allowHiding: false,
        },
        {
          screenField: "CustomerName",
          gridLabel: "CustomerNameFilter", // only added to bypass the having the same 'name' for 2 columns
          dataField: "CustomerName",
          visible: false,
          showInColumnChooser: false,
          dataType: "string",
          type: "Text",
          filterIndex: 0,
          filterDataField: "CustomerSearchText",
        },
        {
          screenField: "SurveyTemplateName",
          dataField: "SurveyTemplateName",
          filterDataField: "SurveyTemplateName",
          label: "Survey Name",
        },
        {
          screenField: "Date",
          dataField: "SurveyTemplateStartDate",
          dateVariant: "UTC",
          label: "Survey Start",
          filterLabel: "Survey Start",
          filterDataField: "SurveyTemplateStartDate",
          filterIndex: 2,
          sortOrder: "asc",
          filterOperator: "<=",
          filterDefaultValue: this.defaultDateFilterValue,
        },
        {
          screenField: "Date",
          dataField: "SurveyTemplateEndDate",
          dateVariant: "UTC",
          label: "Survey End",
          filterLabel: "Survey End",
          filterDataField: "SurveyTemplateEndDate",
          filterIndex: 3,
          filterOperator: "=",
          sortOrder: "asc",
        },
        {
          screenField: "Date",
          dataField: "StartDate",
          dateVariant: "UTC",
          label: "Response Opened",
          filterLabel: "Response Opened",
          filterDataField: "StartDate",
          filterIndex: 4,
          filterOperator: "=",
          maxWidth: 100,
        },
        {
          screenField: "Date",
          dataField: "EndDate",
          dateVariant: "UTC",
          filterLabel: "Response Completed",
          filterDataField: "EndDate",
          filterIndex: 5,
          label: "Response Completed",
          maxWidth: 100,
        },

        {
          screenField: "Date",
          dataField: "DateCreated",
          dateVariant: "UTC",
          // sortOrder: "desc",
          label: "Created Date",
          filterLabel: "Created Date",
          filterDataField: "DateCreated",
          visible: false,
          // filterIndex: 2,
          // filterOperator: ">",
          // filterDefaultValue: this.defaultDateFilterValue,
        },
        {
          screenField: "SalesRepresentative",
          label: "Sales Rep",
          dataField: "CustomerSalesRepresentativeCode",
          filterLabel: "Sales Rep",
          filterDataField: "CustomerSalesRepresentativeCode",
          filterIndex: 1,
          visible: false,
          showInColumnChooser: false,
          filterDefaultValue: this.getCustomerRepDefault,
        },
        {
          screenField: "SurveyTemplate",
          label: "Template",
          dataField: "SurveyTemplateRecordId",
          filterLabel: "Template",
          filterDataField: "SurveyTemplateRecordId",
          editorTemplate: {
            primary: [
              {
                dataField: "SurveyName",
              },
            ],
          },
          filterIndex: 6,
          searchExpr: ["SurveyName"],
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "CreatedBy",
          label: "Created By",
          dataField: "CreatedBy",
          filterLabel: "Created By",
          filterDataField: "CreatedBy",
          filterIndex: 7,
          maxWidth: ColumnWidth.RepCode.width,
          dataType: "string",
          type: "Text",
        },
        {
          screenField: "Compliance",
          dataField: "Compliance",
          filterLabel: "Compliance",
          filterDataField: "Compliance",
          label: "Compliance",
          filterIndex: 9,
          cellTemplate: "Status",
        },
        {
          screenField: "Status",
          gridDataField: "FriendlyStatus",
          gridLabel: "Status",
          dataField: "FriendlyStatus",
          filterDataField: "FriendlyStatus",
          filterIndex: 8,
          cellTemplate: "Status",
          dataSourceConfig: {
            data: [
              { key: "Active", value: "Active" },
              { key: "Completed", value: "Completed" },
              { key: "Pending", value: "Pending" },
            ],
          },
          valueExpr: "key",
          displayExpr: "value",
        },

        {
          screenField: "GridRecordEllipsisMenu",
          select: false,
          allowSearch: false,
          cssClass: "padding-7",
          ellipsisMenu: {
            itemAction: (data) => {
              var items = [
                {
                  menuText: "Surveys",
                  data: data,
                  clickAction: this.navigateToDestination,
                  disabled: false,
                },
              ];

              return items;
            },
            keyExpr: "menuText",
            displayExpr: "menuText",
          },
          // eslint-disable-next-line no-unused-vars
          makeDisabled: (data) => {
            // if (data) return data.data.Status != "C";
            return true;
          },
        },
      ];
    },
  },
  methods: {
    surveyResponseListPostProcessCallback(data) {
      data.forEach((element) => {
        if (element.StartDate)
          element.StartDate = element.StartDate.dateWithOffset();

        if (element.EndDate) element.EndDate = element.EndDate.dateWithOffset();

        if (element.DateCreated)
          element.DateCreated = element.DateCreated.dateWithOffset();
      });
      return data;
    },
    async setDefaultCustomerRep() {
      var defaultSalesRep = CacheService.getCache(
        "UserDefaultSalesRepresentative"
      );

      if (!defaultSalesRep) {
        await SalesOrderListService.getUserDefaultSalesRepresentative()
          .then((result) => {
            logDev(
              "SalesOrderListService.getUserDefaultSalesRepresentative",
              result
            );
            this.setLoading = false;
            if (result.data.value[0].SalesRepresentativeCode != "") {
              this.CustomerSalesRepresentativeCode =
                result.data.value[0].SalesRepresentativeCode;
            }

            CacheService.saveCache(
              "UserDefaultSalesRepresentative",
              result.data.value[0],
              2
            );
            this.loaded = true;
          })
          .catch((err) => {
            logDev(
              "Error in SalesOrderListService.getUserDefaultSalesRepresentative",
              err
            );

            if (err) {
              this.setLoading = false;
              this.loaded = true;
            }
          });
      } else {
        if (defaultSalesRep.SalesRepresentativeCode != "")
          this.CustomerSalesRepresentativeCode =
            defaultSalesRep.SalesRepresentativeCode;

        this.loaded = true;
      }
    },
    goToCustomerStatementModel(e) {
      this.gcPopupCustomerStatementConfig = {
        visible: true,
        hidden: () => {
          this.gcPopupCustomerStatementConfig.visible = false;
        },
        dataModel: e,
      };
    },
    // eslint-disable-next-line no-unused-vars
    navigateToDestination(e) {
      this.$router.push({
        path: `customer`,
      });
    },
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "Status" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "surveys",
          mode: "review",
          idProperty: "RecordId",
          query: { from: "surveys" },
        });
      }
    },
  },

  async created() {
    await this.setDefaultCustomerRep();
  },
};
</script>

<style lang="scss"></style>
